export default __webpack_public_path__ + "static/media/facebook.67e8d6d8.svg";